import { render } from "./Core.vue?vue&type=template&id=14c79056&ts=true"
import script from "./Core.vue?vue&type=script&lang=ts"
export * from "./Core.vue?vue&type=script&lang=ts"

import "./Core.vue?vue&type=style&index=0&id=14c79056&lang=css"

import exportComponent from "/app/ViewpointPBIEmbedded/ViewpointPBIEmbedded.BFF/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__